// src/pages/AdminRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import useAccessProfile from "../hooks/useAccessProfile";
import { hasRole, isActiveUser } from "../utils/accessControl";

const AdminRoute = ({ children }) => {
  const { currentUser, loading: authLoading } = useAuth();
  const { profile, loading: accessLoading, exists } = useAccessProfile();

  if (authLoading || accessLoading) {
    return <div>Loading...</div>;
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (!exists) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (!isActiveUser(profile)) {
    return <Navigate to="/unauthorized" replace />;
  }

  const email = String(currentUser?.email || "").trim().toLowerCase();
  const isNzStaff = currentUser?.emailVerified && email.endsWith("@nexterzone.com");
  const isAdmin = hasRole(profile, "admin") || isNzStaff;

  return isAdmin ? children : <Navigate to="/unauthorized" replace />;
  };

export default AdminRoute;